// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '5154953d61c97b46d01196836c0d91ceb6c9c5a4';
export const BUILD_NUMBER = '186';
export const BUILD_TIMESTAMP = '2026-07-02T07:09:36.581Z';
